import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export enum ProductLevel {
  Level1 = 'Level1',
  Level2 = 'Level2',
  Level3 = 'Level3',
  PitPat = 'PitPat',
  SmartTag = 'SmartTag'
}

@Component({
  selector: 'app-product-hero',
  templateUrl: './product-hero.component.html',
  styleUrls: ['./product-hero.component.scss'],
})
export class ProductHeroComponent implements OnInit {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() secondarySubtitle: string;

  @Input() level: ProductLevel;
  @Input() badgeUri: string;
  @Input() compareVisible: boolean;
  @Input() buyHidden: boolean;
  @Input() levelsVisible: boolean;
  @Input() buyButtonText: string;
  @Input() disabled: boolean;

  @Output() onBuyClick: EventEmitter<string> = new EventEmitter();
  @Output() onCompareClick: EventEmitter<string> = new EventEmitter();

  public productLevel = ProductLevel;

  buy(): void {
    this.onBuyClick.emit();
  }

  compare(): void {
    this.onCompareClick.emit();
  }

  constructor() {}

  ngOnInit(): void {}
}
